export enum TouchpointHandleAspectRatio {
  ENABLE = 'enable',
  DISABLE = 'disable',
  DISALLOW = 'disallow',
}
